$(function(){
  const $modal   = $('#media-modal');
  const $img     = $modal.find('.modal-img');
  const $iframe  = $modal.find('.modal-video');
  const $prev    = $modal.find('.modal-prev');
  const $next    = $modal.find('.modal-next');
  const $close   = $modal.find('.modal-close');

  let mediaItems = [];
  let idx        = 0;

  $('.archive--list_item').on('click', function(e){
    e.preventDefault();

    const vimeoId = $(this).data('vimeo-id');
    if (vimeoId) {
      // — Vimeo モード —
      // ① 画像を非表示
      $img.css('display','none').attr('src','');
      // ② 矢印ナビを隠す
      $prev.css('display','none');
      $next.css('display','none');
      // ③ iframe を表示して src を再設定
      $iframe
        .css('display','block')
        .attr('src', `https://player.vimeo.com/video/${vimeoId}?autoplay=1`);
      // ④ モーダルを開く
      openModal();
      return;
    }

    // — 画像／スライドモード —
    const images = $(this).data('images');
    mediaItems = (images && images.length)
      ? images.slice()
      : [ $(this).find('.thumbnail').attr('src') ];
    idx = 0;

    // ① iframe をクリアして隠す
    $iframe.css('display','none').attr('src','');
    // ② 画像を表示
    $img
      .attr('src', mediaItems[0])
      .css('display','block');
    // ③ ナビ表示制御
    if (mediaItems.length > 1) {
      $prev.css('display','block');
      $next.css('display','block');
    } else {
      $prev.css('display','none');
      $next.css('display','none');
    }
    // ④ モーダルを開く
    openModal();
  });

  // スライド操作
  $next.on('click', () => {
    idx = (idx + 1) % mediaItems.length;
    $img.attr('src', mediaItems[idx]);
  });
  $prev.on('click', () => {
    idx = (idx - 1 + mediaItems.length) % mediaItems.length;
    $img.attr('src', mediaItems[idx]);
  });

  // モーダル開閉
  function openModal(){
    $('body').css('overflow','hidden');
    $modal.addClass('active');
  }
  function closeModal(){
    $modal.removeClass('active');
    $('body').css('overflow','');
    // 完全リセット
    $img.css('display','none').attr('src','');
    $iframe.css('display','none').attr('src','');
  }
  $close.add($modal).on('click', function(e){
    if (e.target === this || $(this).hasClass('modal-close')) {
      closeModal();
    }
  });
});
